import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "16",
  height: "16",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "m11 0 1 1v2h4v2h-1.09L14 15.1l-1 .9H3l-1-.9L1.1 5H0V3h4V1l1-1h6zm1.9 5H3.1l.81 9h8.18l.81-9zM8.5 6v7h-1V6h1zM11 6v7h-1V6h1zM6 6v7H5V6h1zm4-4H6v1h4V2z",
  fill: "currentColor"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
}
export default { render: render }